export default class PageContents {
  static TableHeaders = class {
    static readonly SKYNODE_COLLECTION = 'Skynodes';
    static readonly PACKAGE_COLLECTION = 'Packages';
    static readonly USER_COLLECTION = 'Admin';
  };
}
